<template>
  <!-- Portfolio -->
  <section class="resume-section" id="portfolio">
    <div class="resume-section-content">
      <h2 class="mb-5">Portfolio</h2>
      <div class="subheading mb-3">Recent Projects</div>
      <div class="row" v-if="projects.isLoading">
        <ContentLoader />
      </div>

      <div class="row" v-else>
        <div
          class="col-lg-4 col-sm-6 mb-4"
          v-for="project in projects"
          :key="project.id"
        >
          <div class="portfolio-item">
            <a
              class="portfolio-link"
              data-toggle="modal"
              href="#portfolioModal"
            >
              <div class="portfolio-hover" @click="onClickProject(project.id)">
                <div class="portfolio-hover-content">
                  <i class="fas fa-search fa-3x"></i>
                </div>
              </div>
              <img
                class="img-fluid"
                :src="require(`@/${project.thumbnailUrl}`)"
                :alt="project.name"
              />
            </a>
            <div class="portfolio-caption">
              <div class="portfolio-caption-heading">
                {{ project.company.name }}
              </div>
              <div class="portfolio-caption-subheading text-muted">
                {{ project.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ContentLoader } from "vue-content-loader";

export default {
  components: { ContentLoader },
  computed: mapGetters(["projects"]),
  methods: {
    ...mapActions(["fetchProjects", "fetchProject"]),
    onClickProject(id) {
      this.fetchProject(id);
    },
  },
  created() {
    this.fetchProjects();
  },
};
</script>
